import { CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { useQuoteWizardContext } from "../QuoteWizardContext";
import { COVERAGE_TYPES, RFP_COVERAGE_TYPES } from "../constants";
import { CoverageIcon } from "@/components/benefits/v2/typeIcons";

export function Step2CoverageTypes() {
  const { quoteData, updateQuoteData, isRFPMode } = useQuoteWizardContext();

  // Use RFP coverage types (with Disability and Voluntary) for RFP mode.
  // Already in canonical order (medical, dental, vision, life...voluntary) -
  // color + icon + label is enough to tell types apart, no section headers needed.
  const coverageOptions = isRFPMode ? RFP_COVERAGE_TYPES : COVERAGE_TYPES;

  const toggle = (id: string) => {
    const isSelected = quoteData.coverageTypes.includes(id);
    updateQuoteData({
      coverageTypes: isSelected
        ? quoteData.coverageTypes.filter((t) => t !== id)
        : [...quoteData.coverageTypes, id],
    });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-lg font-semibold mb-2">Select Coverage Types</h3>
        <p className="text-muted-foreground">
          Choose the types of coverage to include in your {isRFPMode ? "RFP" : "quote"}
        </p>
      </div>

      <div className="flex flex-wrap gap-2">
        {coverageOptions.map((coverage) => {
          const isSelected = quoteData.coverageTypes.includes(coverage.id);
          return (
            <div
              key={coverage.id}
              className={cn(
                "flex items-center gap-2 rounded-lg border px-2.5 py-1.5 transition-colors cursor-pointer",
                isSelected ? "border-primary/40 bg-primary/5" : "hover:bg-muted/40"
              )}
              onClick={() => toggle(coverage.id)}
            >
              <CoverageIcon planType={coverage.id} size="sm" />
              <span className="flex items-center gap-1 text-sm font-medium whitespace-nowrap">
                {coverage.label}
                {isSelected && <CheckCircle className="h-3.5 w-3.5 shrink-0 text-primary" />}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
